type DepartamentoId = number | string;

type TimelineSnapshot = {
  id_departamento?: DepartamentoId | null;
};

type TimelineItemWithDepartamento = {
  new?: string | TimelineSnapshot | null;
  old?: string | TimelineSnapshot | null;
  id_departamento?: DepartamentoId | null;
  tarefa?: TimelineSnapshot | null;
  nota?: TimelineSnapshot | null;
};

export function parseTimelineSnapshot<T extends TimelineSnapshot>(
  value: unknown,
): T | null {
  if (!value) return null;

  if (typeof value === "object" && !Array.isArray(value)) {
    return value as T;
  }

  if (typeof value !== "string") return null;

  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? (parsed as T)
      : null;
  } catch {
    return null;
  }
}

export function getTimelineItemDepartamentoId(
  item: TimelineItemWithDepartamento,
) {
  const parsedNew = parseTimelineSnapshot(item?.new);
  const parsedOld = parseTimelineSnapshot(item?.old);

  return (
    parsedNew?.id_departamento ??
    parsedOld?.id_departamento ??
    item?.tarefa?.id_departamento ??
    item?.nota?.id_departamento ??
    item?.id_departamento ??
    null
  );
}

export function timelineItemBelongsToDepartamento(
  item: TimelineItemWithDepartamento,
  departamentoActive: unknown,
) {
  if (departamentoActive === undefined || departamentoActive === null) {
    return true;
  }
  if (Number(departamentoActive) === 0) return true;

  const departamentoId = getTimelineItemDepartamentoId(item);
  return String(departamentoId) === String(departamentoActive);
}
